import React from 'react'

import { ExtendedTable } from '@app/components'
import { Show } from '@app/components/util'

import styles from './styles.module.scss'

import type { BaseDataSourceType } from '@app/components/ExtendedTable/types'
import type { ExtendedTableWithSidebarFC, ExtendedTableWithSidebarProps } from './types'

export const ExtendedTableWithSidebar: ExtendedTableWithSidebarFC = <DataSourceType extends BaseDataSourceType>({
  isSidebarOpen,
  sidebar,
  ...extendedTableProps
}: ExtendedTableWithSidebarProps<DataSourceType>) => {
  return (
    <section className={ styles.extendedTableWithSidebar }>
      <Show condition={ isSidebarOpen }>
        <aside className={ styles.extendedTableWithSidebar__sidebar }>{ sidebar }</aside>
      </Show>

      <ExtendedTable
        { ...extendedTableProps }
        className={ styles.extendedTableWithSidebar__table }
      />
    </section>
  )
}
